import { createApp } from 'vue'
import App from './App.vue'
import './assets/theme.css'
import './registerServiceWorker'
import router from './router'
import store from './store'

function getInitialTheme() {
  try {
    const savedTheme = localStorage.getItem('themeMode')
    if (savedTheme === 'dark' || savedTheme === 'light') {
      return savedTheme
    }
  } catch (error) {
    // Fall back to the system preference when storage is unavailable.
  }

  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}

document.documentElement.setAttribute('data-theme', getInitialTheme())

createApp(App).use(store).use(router).mount('#app')
